import { SYM_IS_PROP_ROOT, SYM_ROOT_PROP } from "../../../enum/Symbol"
import useDiscard from "../../../useDiscard";
import useWeakMap from "../../../utils/useWeakMap";

const store = useWeakMap();
const propManyRoots = useWeakMap();

const onDiscardProp = (props) => {
    store.delete(props);
    propManyRoots.delete(props);
}


const storePropsManyRoots = (props, rootProps) => {
    if (!propManyRoots.has(props)) {
        propManyRoots.set(props, new Set());
    }
    propManyRoots.get(props).add(rootProps);
    const superRoot = isRoot(rootProps) ? rootProps : getRootProps(rootProps);
    if (superRoot) {
        propManyRoots.get(props).add(superRoot);
    }
}

export const useMarkPropIsRoot = (...restProps) => {
    for (let i in restProps) {
        store.set(restProps[i], SYM_IS_PROP_ROOT);
        useDiscard(restProps[i], onDiscardProp)
    }
}

export const isRoot = props => store.get(props) === SYM_IS_PROP_ROOT;

export const useMarkRootProp = (props, rootProps, force = false) => {
    if (isRoot(props) && !force) return;
    storePropsManyRoots(props,rootProps);
    if (store.has(props)) return;
    const targetRoot = isRoot(rootProps) ? rootProps : getRootProps(rootProps);
    if (!targetRoot) { return; }
    store.set(props, targetRoot);
    useDiscard(props, onDiscardProp)
}

export const getRootProps = (props) => {
    try {
        return isRoot(props) ? null : store.get(props);
    } catch (ex) {
        return null;
    }
}

export const getAllRoots = (props) => {
    const allRoots = propManyRoots.get(props);
    return allRoots ? Array.from(allRoots) : null
}